
import emoji from "react-easy-emoji";

const illustration = {
  animated: true 
};

const greeting = {
  username: "Yash Vardhan",
  title: "Hey! I'm Yash",
  subTitle: emoji(
    "Full-Stack Developer | Aspiring Programmer | Mathematics and Computing'2024 at IIT(ISM) Dhanbad"
  ),
  resumeLink:
    "https://docs.google.com/document/d/1VA7lokLGIobz4C86DL1Im0B10lavi-ZErS6p91ObYqg/edit?usp=sharing",
  displayGreeting: true 
};

const socialMediaLinks = {
  github: "https://github.com/Grumpyyash",
  linkedin: "https://www.linkedin.com/in/yash-vardhan-688952188/",
  gmail: "yashvardhan513@gmail.com",
  facebook: "https://www.facebook.com/profile.php?id=100039280729807",
  medium: "https://yash-dn.medium.com/",
  twitter: "https://twitter.com/Yash_dn",
  display: true
};

const skillsSection = {
  title: "What I do",
  skills: [
    emoji(
      "Open Source ❤️"
    ),
    emoji("Full-Stack Applications with hands on Native Development 🚀"),
    emoji("Competitive Programming 🚀"),
    emoji(
      "Javascript >>>>> Python 🎯"
    )
  ],

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "firebase",
      fontAwesomeClassname: "fas fa-fire"
    }
  ],
  display: true 
};

const educationInfo = {
  display: true, 
  schools: [
    {
      schoolName: "IIT(ISM) Dhanbad",
      logo: require("./assets/images/ism-logo.png"),
      subHeader: "Integrated Master of Technology in Mathematics and Computing",
      duration: "July 2019 - Present",
      desc: "CGPA: 9.34"
    }
  ]
};


const techStack = {
  viewSkillBars: true,
  experience: [
    {
      Stack: "Frontend Dev",
      progressPercentage: "85%" 
    },
    {
      Stack: "Backend Dev",
      progressPercentage: "75%"
    },
    {
      Stack: "Native Dev",
      progressPercentage: "65%"
    },
    {
      Stack: "Programming",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false
};


const workExperiences = {
  display: true,
  experience: [
    {
      role: "Google Summer of Code'21",
      company: "SCoRe Lab",
      companylogo: require("./assets/images/gsoc-logo.png"),
      date: "May 2021 – Aug 2021",
      desc: "Student Developer to work on the project Webiu and develop a genearlized website builder along with npm and gatsby plugins",
    },
    {
      role: "Developer",
      company: "Koobbox",
      companylogo: require("./assets/images/kb-logo.jpeg"),
      date: "June 2020 – Aug 2020",
      desc: "Worked in ateam to develop their official e-commerce website from scratch and integarte APIs, payment gateways and deployment"
    },
    {
      role: "Developer",
      company: "ACM Student Chapter",
      companylogo: require("./assets/images/acm-logo.jpg"),
      date: "June 2020 – Present",
      desc: "Lead developer at the chapter, built their official website and engaged in promoting open-source software"
    }
  ]
};


const openSource = {
  showGithubProfile: "true",
  display: true 
};

const bigProjects = {
  title: "Open-Source ❤️",
  subtitle: "Some of the best Communities I have had which helped me grow!",
  projects: [
    {
      image: require("./assets/images/score-logo.jpeg"),
      projectName: "SCoRe Lab/Webiu",
      projectDesc: "A generalized website builder built using React Js and Gatsby Js which magnificantly eases the process of getting a website up and running",
      footerLink: [
        {
          name: "Explore Repository",
          url: "https://github.com/scorelab/Webiu"
        },
        {
          name: "Website",
          url: "https://scorelab.org/"
        }
      ]
    },
    {
      image: require("./assets/images/layer-logo.svg"),
      projectName: "Layer5 | Layer5",
      projectDesc: "The Layer5 community represents the largest collection of service mesh projects and their maintainers in the world.",
      footerLink: [
        {
          name: "Explore Repository",
          url: "https://github.com/layer5io/layer5"
        },
        {
          name: "Website",
          url: "https://layer5.io/"
        }
      ]
    },
    {
      image: require("./assets/images/nighthawk-logo.svg"),
      projectName: "Layer5 | GetNighthawk",
      projectDesc: "Nighthawk is a Layer 7 (HTTP/HTTPS/HTTP2) performance characterization tool. Nighthawk is Envoy’s load generator and is written in C++",
      footerLink: [
        {
          name: "Explore Repository",
          url: "https://github.com/layer5io/getnighthawk"
        },
        {
          name: "Website",
          url: "https://getnighthawk.dev/"
        }
      ]
    }
  ],
  display: true
};

const featuredProjects = {
  title: "Featured Personal Projects",
  subtitle: "Projects that I could build in the due course of learning",
  projects: [
    {
      image: require("./assets/images/annadata.png"),
      projectName: "Annadata",
      projectDesc: "A full-stack project swiften by ML for complete assistance of farmers right from sowing till harvesting",
      footerLink: [
        {
          name: "Explore Project",
          url: "https://github.com/orgs/AnnadataHackfest/dashboard"
        }
      ]
    },
    {
      image: require("./assets/images/reengine.png"),
      projectName: "ReEngine-IT",
      projectDesc: "A web application to provide an interface for trading of products, especially among college students",
      footerLink: [
        {
          name: "Explore Repository",
          url: "https://github.com/Grumpyyash/ReEngine-IT-MERN"
        },
        {
          name: "Live",
          url: "https://quiet-brushlands-77835.herokuapp.com/"
        }
      ]
    },
    {
      image: require("./assets/images/medifast.png"),
      projectName: "MediFast",
      projectDesc: "A cross-platform application to assist complete healthcare by minimizing the needs to go out of home",
      footerLink: [
        {
          name: "Explore Repository",
          url: "https://github.com/Grumpyyash/MediFast"
        },
        {
          name: "Live",
          url: "https://evening-meadow-96782.herokuapp.com/"
        }
      ]
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Achievements 🏆 "),
  subtitle:
    "Some of the achievements that keeps me motivated!",

  achievementsCards: [
    {
      title: "3rd Runner up HackFest'21",
      subtitle:
        "National Level Development Hackathon Conducted by IIT Dhanbad",
      image: require("./assets/images/hack-logo.jpg"),
      footerLink: [
        {
          name: "GitHub Repo",
          url: "https://github.com/orgs/AnnadataHackfest/dashboard"
        }
      ]
    },
    {
      title: "Winner FallFest'20",
      subtitle:
        "National Level Development hackathon conducted by ACM student chapter",
      image: require("./assets/images/acm-logo.jpg"),
      footerLink: [
        {
          name: "GitHub Repo",
          url: "https://github.com/Grumpyyash/MediFast"
        }
      ]
    },

    {
      title: "1st Runner up Hackoverflow'21",
      subtitle: "Best Feasibility of idea Award from NIT Durgapur",
      image: require("./assets/images/overflow-logo.jpeg"),
      footerLink: [
        {
          name: "Devfolio Submission",
          url: "https://devfolio.co/submissions/medifast-5d91"
        }
      ]
    }
  ],
  display: true
};

const blogSection = {
  title: "Blogs",
  subtitle:
    "Some of the experiences of my really small programming journey",

  blogs: [
    {
      url: "https://medium.com/scorelab/gsoc-2021-a-new-beginning-6b3e77b0f204",
      title: "GSoC 2021: A New Beginning",
      description:
        "I share my experience of getting into open-source and more about the orgaization that I chose for GSoC"
    },
    {
      url: "https://medium.com/scorelab/gsoc-2021-community-bonding-3e06c4e6e357",
      title: "GSoC 2021: Community Bonding Period",
      description:
        "What is Community Bonding Period in GSoC and how it helps you grow as a developer in community"
    },
    {
      url: "https://medium.com/scorelab/gsoc-2021-with-score-lab-week-1-e78b5ae2ad7",
      title: "GSoC 2021: Week-1",
      description:
        "How did I get started with Google Summer of Code 2021 it its first week of initiation"
    }
  ],
  display: true
};


const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Have something for me even cricket, reach out to me!",
  number: "+91-9065676023",
  email_address: "yashavardhan513@gmail.com"
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  featuredProjects,
  achievementSection,
  blogSection,
  contactInfo
};
